import {useEffect, useRef, useState} from 'react';
import {getAllVendors} from "../../api/Api";
import {Table} from 'antd';
import {getColumnSearchProps} from "../widget/SearchProps";
import {Link} from "react-router";

export const AllVendors = ({refresh, onRefresh, onApiFail, props}) => {
    const [vendors, setVendors] = useState([]);

    // for use with search props
    const searchInput = useRef(null);

    useEffect(() => {
        getAllVendors().then(r => {
            const result = r.map(l => {
                return {
                    ...l,
                    key: l.id
                }
            })
            console.log(`vendors ${JSON.stringify(result)}`);
            setVendors(result);
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        })
    }, [refresh, onApiFail]);

    const columns = [
        {
            title: 'Company',
            dataIndex: 'company',
            key: 'company',
            render: (val, record, index) => {
                return <Link to={`/vendor/${record.id}`}>{val}</Link>
            },
            ...getColumnSearchProps(`company`, searchInput),
            sorter: (a, b) => a.company.toLowerCase().localeCompare(b.company.toLowerCase()),
        },
    ];


    return <div style={{width:'500px'}}>
        <Table dataSource={vendors} columns={columns} pagination={false} />
    </div>
}